import styled from 'styled-components';

export const H4 = styled.h4`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: 18px;
  line-height: 27px;
  color: ${({ theme }) => theme.algoanBlue};
  margin: 0;
`;
